/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_h2h_legend_ahead = /** @type {(inputs: { driver: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver} ahead`)
};

const es_f1_h2h_legend_ahead = /** @type {(inputs: { driver: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver} adelante`)
};

const de_f1_h2h_legend_ahead = /** @type {(inputs: { driver: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver} vorne`)
};

const nl_f1_h2h_legend_ahead = /** @type {(inputs: { driver: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver} voor`)
};

const fr_f1_h2h_legend_ahead = /** @type {(inputs: { driver: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver} devant`)
};

const it_f1_h2h_legend_ahead = /** @type {(inputs: { driver: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver} davanti`)
};

const pt_br2_f1_h2h_legend_ahead = /** @type {(inputs: { driver: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver} na frente`)
};

const pt_f1_h2h_legend_ahead = /** @type {(inputs: { driver: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver} à frente`)
};

const ja_f1_h2h_legend_ahead = /** @type {(inputs: { driver: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver} 先行`)
};

const zh_f1_h2h_legend_ahead = /** @type {(inputs: { driver: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver}领先`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ driver: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_h2h_legend_ahead = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_h2h_legend_ahead(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_h2h_legend_ahead", locale)
	if (locale === "en") return en_f1_h2h_legend_ahead(inputs)
	if (locale === "es") return es_f1_h2h_legend_ahead(inputs)
	if (locale === "de") return de_f1_h2h_legend_ahead(inputs)
	if (locale === "nl") return nl_f1_h2h_legend_ahead(inputs)
	if (locale === "fr") return fr_f1_h2h_legend_ahead(inputs)
	if (locale === "it") return it_f1_h2h_legend_ahead(inputs)
	if (locale === "pt-BR") return pt_br2_f1_h2h_legend_ahead(inputs)
	if (locale === "pt") return pt_f1_h2h_legend_ahead(inputs)
	if (locale === "ja") return ja_f1_h2h_legend_ahead(inputs)
	return zh_f1_h2h_legend_ahead(inputs)
};